var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 140 37",
    fill: "white",
    style: {
      height: "2rem",
      marginLeft: 10,
      marginTop: 4,
      marginBottom: 12
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.307 12.018c0-.99.81-2.158 2.818-2.158 1.71 0 3.238.66 4.407 2.098v1.83c-1.53.42-3.298.63-4.107.63-2.428 0-3.118-1.38-3.118-2.4m-3.717-.06c0 2.758 2.368 4.767 6.266 4.767 1.68 0 3.268-.27 4.557-.69v.48c0 2.338-2.04 3.148-3.628 3.148-.9 0-2.848-.06-4.766-1.56l-1.38 2.458c1.68 1.71 4.257 2.248 6.416 2.248 6.206 0 7.135-3.987 7.135-6.626V7.31H36.5v2.25c-.84-1.35-2.728-2.578-5.186-2.578-2.908 0-5.726 1.71-5.726 4.976",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.47 22.81c1.47 0 3.507-.33 5.846-2.04l-1.71-2.638c-1.56 1.29-3.388 1.38-3.957 1.38-2.938 0-5.007-1.888-5.007-4.617 0-2.698 2.07-4.617 5.007-4.617.57 0 2.4.12 3.957 1.38l1.71-2.608c-2.338-1.74-4.377-2.07-5.846-2.07-5.276 0-8.544 3.418-8.544 7.825 0 4.497 3.178 8.004 8.544 8.004",
    transform: "matrix(1 0 0 -1 0 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.09 22.48h3.688V7.31H58.09v15.17zm1.86 6.835c1.38 0 2.458-1.02 2.458-2.338s-1.08-2.308-2.458-2.308-2.398.99-2.398 2.308 1.02 2.338 2.398 2.338z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.516 22.48h3.688v-2.548c.96 1.98 2.758 2.878 4.917 2.878 3.777 0 5.606-2.73 5.606-7.105V7.31H74.04v8.364c0 2.638-1.1 4.017-2.938 4.017-2.16 0-3.898-1.62-3.898-4.796V7.31h-3.688v15.17z",
    transform: "matrix(1 0 0 -1 0 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65 10.07c2.518 0 4.527 1.71 4.527 4.706 0 2.938-1.89 4.947-4.617 4.947-2.788 0-4.376-2.19-4.376-4.797 0-2.698 1.708-4.857 4.467-4.857m-5.337-4.917c1.2-1.05 3.118-1.83 4.947-1.83 2.608 0 4.827 1.2 4.827 4.467V9.56c-1.05-1.59-3.058-2.58-5.188-2.58-4.496 0-7.434 3.538-7.434 7.975 0 4.287 2.818 7.855 7.464 7.855 2.04 0 3.928-.84 5.157-2.578v2.248h3.687V8.96c0-6.266-3.267-8.843-8.064-8.843-3.298 0-5.366.93-6.865 2.158.5.96.99 1.92 1.47 2.878",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.808 28.297V25.2h-6.475V7.3h-3.837v17.9h-6.416v3.088zm1.62 0h3.987l5.217-16.1 5.216 16.1h3.988L132.46 7.3h-3.687l-7.345 20.986M25.474 7.322h-4.428l-6.027 8.634H8.76l-2.53 3.6h12.75c1.266 0 2.305 1.145 2.3 2.583 0 1.4-1.035 2.542-2.3 2.542H2.624L.07 28.32l18.195.01c2.058 0 3.734-.65 4.968-1.95 1.116-1.167 1.672-2.567 1.672-4.232 0-1.388-.5-2.635-1.477-3.728-.966-1.1-2.306-1.793-3.978-2.16l6.023-8.94z",
    transform: "matrix(1 0 0 -1 0 37)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49418f11.svg";
export { ForwardRef as ReactComponent };